import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.yesNoList,"item-value":"value","item-text":"name","label":_vm.label,"clearable":_vm.clearable,"outlined":""},model:{value:(_vm.activeValue),callback:function ($$v) {_vm.activeValue=$$v},expression:"activeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }